 

 

  

 

 

<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                
                <v-col cols="12" md="6" class="px-10">
                    <h1>Chatbots</h1>
                    <h2 class="text-h5 font-italic mb-5">Automated Customer Conversations</h2>
                    <div>
                        
                        <!-- <ul class="mt-3">
                            <li class="mb-3"><b>Instant Engagement:</b> Answer common customer questions immediately, keeping visitors engaged without waiting for a human agent.</li>

                            <li class="mb-3"><b>Lead Capture:</b> Gather key customer details automatically, ensuring high-interest prospects are flagged and routed to your team.</li>

                            <li class="mb-3"><b>Smart Routing:</b> Detect high-intent inquiries and escalate them to the right agent seamlessly, improving conversion and satisfaction.</li>

                            <li class="mb-3"><b>Time-Saving:</b> Reduce repetitive inquiries and free your team to focus on complex, high-value tasks.</li>

                            <li class="mb-3"><b>Easy Deployment:</b> Add chatbots to high-traffic pages with minimal setup, creating a polished experience for new visitors.</li>

                            <li class="mb-3"><b>Flexible Use Cases:</b> From automated Q&A to lead capture and agent escalation, chatbots adapt to your customer needs.</li>
                        </ul> -->

                        <v-card class="mb-3">
                        <v-card-title>Instant Engagement & Lead Capture:</v-card-title>
                        <v-card-text>Answer common questions immediately while gathering visitor info and flagging high-interest prospects for your team.</v-card-text>
                        </v-card>

                        <v-card class="mb-3">
                        <v-card-title>Smart Routing:</v-card-title>
                        <v-card-text>Detect high-intent inquiries and escalate them to the right agent seamlessly, improving conversion and satisfaction.</v-card-text>
                        </v-card>

                        <v-card class="mb-3">
                        <v-card-title>Time-Saving:</v-card-title>
                        <v-card-text>Reduce repetitive inquiries and free your team to focus on complex, high-value tasks.</v-card-text>
                        </v-card>

                        <v-card class="mb-3">
                        <v-card-title>Easy Deployment:</v-card-title>
                        <v-card-text>Add chatbots to high-traffic pages with minimal setup, creating a polished experience for new visitors.</v-card-text>
                        </v-card>

                    </div>
                </v-col>
                <v-col cols="12" md="2" class="px-10 text-center d-flex justify-center">
                    <v-icon size="300px">mdi-robot-happy</v-icon> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'CampaignsSurveys',
}
</script>

<style lang="scss">

hr {
    margin: 1em 0;
    width: 50%;
}

</style>